import React, { useState } from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    round
} from '../../../business-components/round/round'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    //GridContainerGridItemButtonIncluirLinha,
    GridItem1xs2,
    GridItem2,
    GridItem2xs6,
    GridItem3xs10,
    GridItem3xs10NotIsXsDownScreen,
    GridItem4xs6,
    GridItem4xs10,
    GridItem4xs12,
    GridItem5,
    GridItem5xs12,
    GridItem6,
    GridItem6xs12,
    GridItem7,
    GridItem8xs12,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoRecursoFinanceiroList from '../../../business-rules/List/tipoRecursoFinanceiroList'

import {
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha,
    ButtonAlterarTodosFamiliaresInventario,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoRecursosFinanceiros,
    rowPertentePageRecursosFinanceiros,
    setPageInclusaoRecursosFinanceiros,
    Familiar,
    TipoRecursoFinanceiro,
    IconButtonClearEntradaDadosRecursosFinanceiros,
    Valor,
    ValorAporteDividendos,
    AporteOriundoReceitaMensal,
    TipoPeriodicidadeAporteDividendos,
    MesAnoInicialAporteDividendos,
    MesAnoFinalAporteDividendos,
    Instituicao,
    DescricaoOutros,
    PercRentabilidadeAnualRecursoFinanceiro,
    AporteDividendosAteAposentadoria,
} from '../garantias-form/GarantiasCompRecursosFinanceiros'

import {
    incrementaContRecursosFinanceiros,
    processaRegistrosDefaultIniciaisRecursosFinanceiros,
    processaValoresDefaultIniciaisRecursosFinanceiros,
    calculaTotaisRecursosFinanceiros,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    processaFormRegistrosDefaultIniciaisSortAscFamiliar
} from './FormService'

import {
    AlterarFamiliarInventarioRecursosFinanceiros,
    ButtonAlterarFamiliarInventarioRecursosFinanceiros,
} from './FormCompRecursosFinanceiros'

import GarantiasFormRecursosFinanceirosItem from '../garantias-form/GarantiasFormRecursosFinanceirosItem'



const IntituicaoDescricaoOutrosPercRentabilidade = ({ item, ind, handleChange, linhaTipoLicenca,
    tipoRecursoFinanceiroSelecionado, expandiu }) => {

    return (
        <GridContainer>
            <GridItem4xs12>
                <Instituicao
                    item={item}
                    ind={ind}
                    handleChange={handleChange} 
                    expandiu={expandiu}
                />
            </GridItem4xs12>
            <GridItem6xs12>
                <DescricaoOutros
                    item={item}
                    ind={ind}
                    handleChange={handleChange} 
                    expandiu={expandiu}
                />
            </GridItem6xs12>
            <GridItem2xs6>
                {tipoRecursoFinanceiroSelecionado.informaPercRentabilidadeRecursoFinanceiro === "S" &&
                linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                    <PercRentabilidadeAnualRecursoFinanceiro
                        item={item}
                        ind={ind}
                        handleChange={handleChange}
                        labelCurto={true}
                        expandiu={expandiu}
                    />
                )}
            </GridItem2xs6>
        </GridContainer>
    )
}

const ExpandirExcluir = ({ values, handleChange, setFieldValue, linhaTipoLicenca/*, jsonConfiguracao*/, title, arrayHelpers,
    item, ind, tipoRecursoFinanceiroSelecionado, setExpandiu}) => {

    return (
        <GridContainer>
            <GridItem6
                className="mt-2"
            >
                <CustomizedDialogsPopup
                    maxWidth="sm"
                    popupTitle={title}
                    tooltipTitle={LABEL.expandir}
                    PopupButton={IconButtonMaisInformacoes}
                    popupButtonDestaque={false}
                    DialogContentClassName={CLASSNAME().dialogContentClassNameFormExpandir}
                    popupComponent={
                        <GarantiasFormRecursosFinanceirosItem
                            values={values}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                            arrayHelpers={arrayHelpers}
                            linhaTipoLicenca={linhaTipoLicenca}
                            tipoRecursoFinanceiroSelecionado={
                                tipoRecursoFinanceiroSelecionado
                            }
                            item={item}
                            ind={ind}
                            //jsonConfiguracao={jsonConfiguracao}
                            simplificado={true}
                        />
                    }
                    open={setExpandiu}
                    afterClose={setExpandiu}
                />
            </GridItem6>
            <GridItem6
                className="mt-2"
            >
                <IconButtonClearEntradaDadosRecursosFinanceiros
                    values={values}
                    setFieldValue={setFieldValue}
                    item={item}
                    ind={ind}
                    arrayHelpers={arrayHelpers}
                />
            </GridItem6>
        </GridContainer>
    )
}
const FormFormRecursosFinanceiros = ({ values, handleChange, setFieldValue, linhaTipoLicenca/*, jsonConfiguracao*/, title }) => {
    
    const [expandiu, setExpandiu] = useState(false)

    const temAporte = (item) => {

        return (
                item.valorAporteDividendos &&
                round(item.valorAporteDividendos, 2) !== 0
            ) || 
            (
                item.valorAporteEmpresa &&
                round(item.valorAporteEmpresa, 2) !== 0
            )
    }

    calculaTotaisRecursosFinanceiros(values)

    useSingleton(async () => {

        processaFormRegistrosDefaultIniciaisSortAscFamiliar(values, values.totalRecursosFinanceiros,
            processaRegistrosDefaultIniciaisRecursosFinanceiros, values.recursosFinanceiros)

        values.pageRecursosFinanceiros = obtemPage(values.pageRecursosFinanceirosList, HARDCODE.idFamiliarPage)
    })

    salvaPage(values.pageRecursosFinanceiros, values.pageRecursosFinanceirosList, HARDCODE.idFamiliarPage)

    let indAux = 0

    values.recursosFinanceirosPagination =
        values.recursosFinanceiros
            ?
                values.recursosFinanceiros.filter(item => !item.idReceitaMensal)
            :
                []

    const isXsDownScreen = IsXsDownScreen()



    return (
        <FieldArray name="recursosFinanceiros">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.recursosFinanceiros?.map((item, ind) => {

                            if (!item.idReceitaMensal && rowPertentePageRecursosFinanceiros(values, indAux++)) {

                                processaValoresDefaultIniciaisRecursosFinanceiros(item, values)

                                let tipoRecursoFinanceiroSelecionado = pesquisaList(tipoRecursoFinanceiroList, 
                                    item.tipoRecursoFinanceiro)

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem4xs10>
                                                <GridContainer>
                                                    <GridItem5>
                                                        <Familiar
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem5>
                                                    
                                                    <GridItem7>
                                                        <TipoRecursoFinanceiro
                                                            TextFieldNumberSelectTipoRecursoFinanceiro={
                                                                TextFieldNumberSelect
                                                            }
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            //jsonConfiguracao={jsonConfiguracao}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem7>
                                                </GridContainer>
                                            </GridItem4xs10>

                                            {item.tipoRecursoFinanceiro
                                                ?
                                                    <>
                                                        <GridItem3xs10>
                                                            <GridContainer>
                                                                <GridItem6>
                                                                    {tipoRecursoFinanceiroSelecionado.informaReservaAtual !== "0" && (
                                                                        <Valor
                                                                            values={values}
                                                                            item={item}
                                                                            ind={ind}
                                                                            handleChange={handleChange}
                                                                            tipoRecursoFinanceiroSelecionado={
                                                                                tipoRecursoFinanceiroSelecionado
                                                                            }
                                                                            expandiu={expandiu}
                                                                        />
                                                                    )}
                                                                </GridItem6>

                                                                <GridItem6>
                                                                    {tipoRecursoFinanceiroSelecionado.informaAporteDividendos === "S" && (
                                                                        <ValorAporteDividendos
                                                                            item={item}
                                                                            ind={ind}
                                                                            handleChange={handleChange}
                                                                            tipoRecursoFinanceiroSelecionado={
                                                                                tipoRecursoFinanceiroSelecionado
                                                                            }
                                                                            expandiu={expandiu}
                                                                        />
                                                                    )}
                                                                </GridItem6>
                                                            </GridContainer>
                                                        </GridItem3xs10>

                                                        {!isXsDownScreen && (
                                                            <GridItem4xs10>
                                                                <IntituicaoDescricaoOutrosPercRentabilidade
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    linhaTipoLicenca={linhaTipoLicenca}
                                                                    tipoRecursoFinanceiroSelecionado={
                                                                        tipoRecursoFinanceiroSelecionado
                                                                    }
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem4xs10>
                                                        )}
                                                    </>
                                                :
                                                    <GridItem3xs10NotIsXsDownScreen/>
                                            }

                                            {!isXsDownScreen && (
                                                <GridItem1xs2>
                                                    <ExpandirExcluir
                                                        values={values}
                                                        handleChange={handleChange}
                                                        setFieldValue={setFieldValue}
                                                        linhaTipoLicenca={linhaTipoLicenca}
                                                        /*jsonConfiguracao={jsonConfiguracao}*/
                                                        title={title}
                                                        arrayHelpers={arrayHelpers}
                                                        item={item}
                                                        ind={ind}
                                                        tipoRecursoFinanceiroSelecionado={tipoRecursoFinanceiroSelecionado}
                                                        setExpandiu={setExpandiu}
                                                    />
                                                </GridItem1xs2>
                                            )}
                                        </GridContainer>

                                        {item.tipoRecursoFinanceiro && temAporte(item) && (
                                            <GridContainer>
                                                {!isXsDownScreen && (
                                                    <GridItem4xs10/>
                                                )}

                                                <GridItem3xs10>
                                                    <GridContainer>
                                                        <GridItem6>
                                                            <TipoPeriodicidadeAporteDividendos
                                                                item={item}
                                                                ind={ind}
                                                                handleChange={handleChange}
                                                                expandiu={expandiu}
                                                            />
                                                        </GridItem6>
                                                        <GridItem6>
                                                            <MesAnoInicialAporteDividendos
                                                                item={item}
                                                                ind={ind}
                                                                handleChange={handleChange}
                                                                expandiu={expandiu}
                                                            />
                                                        </GridItem6>
                                                    </GridContainer>
                                                </GridItem3xs10>

                                                <GridItem4xs10>
                                                    <GridContainer>
                                                        <GridItem4xs6>
                                                            {!item.aporteDividendosAteAposentadoria &&
                                                            item.tipoPeriodicidadeAporteDividendos !== HARDCODE.idTipoPeriodicidadeUnica && (
                                                                <MesAnoFinalAporteDividendos
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            )}
                                                        </GridItem4xs6>

                                                        <GridItem8xs12>
                                                            <GridContainer>
                                                                {tipoRecursoFinanceiroSelecionado.informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos === "S" &&
                                                                linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' &&
                                                                !item.aporteOriundoRealocacaoCarteiraInvestimentos && !expandiu
                                                                    ?
                                                                        <GridItem12
                                                                            className='mt--1'
                                                                        >
                                                                            <AporteOriundoReceitaMensal
                                                                                item={item}
                                                                                ind={ind}
                                                                                handleChange={handleChange}
                                                                            />
                                                                        </GridItem12>
                                                                    :
                                                                        <GridItem12
                                                                            className='mt-6'
                                                                        />
                                                                }

                                                                {item.tipoPeriodicidadeAporteDividendos !== HARDCODE.idTipoPeriodicidadeUnica && !expandiu && (
                                                                    <GridItem12
                                                                        className='mt--6'
                                                                    >
                                                                        <AporteDividendosAteAposentadoria
                                                                            item={item}
                                                                            ind={ind}
                                                                            handleChange={handleChange}
                                                                            tipoRecursoFinanceiroSelecionado={
                                                                                tipoRecursoFinanceiroSelecionado
                                                                            }
                                                                        />
                                                                    </GridItem12>
                                                                )}
                                                            </GridContainer>
                                                        </GridItem8xs12>
                                                    </GridContainer>
                                                </GridItem4xs10>
                                            </GridContainer>
                                        )}

                                        {isXsDownScreen && (
                                            <GridContainer>
                                                <GridItem10>
                                                    <IntituicaoDescricaoOutrosPercRentabilidade
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                        linhaTipoLicenca={linhaTipoLicenca}
                                                        tipoRecursoFinanceiroSelecionado={
                                                            tipoRecursoFinanceiroSelecionado
                                                        }
                                                    />
                                                </GridItem10>

                                                <GridItem2
                                                    className={
                                                        tipoRecursoFinanceiroSelecionado
                                                            .informaPercRentabilidadeRecursoFinanceiro === "S" &&
                                                        linhaTipoLicenca
                                                            .exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S'
                                                            ?
                                                                'mt-37'
                                                            :
                                                                'mt-19'
                                                    }
                                                >
                                                    <ExpandirExcluir
                                                        values={values}
                                                        handleChange={handleChange}
                                                        setFieldValue={setFieldValue}
                                                        linhaTipoLicenca={linhaTipoLicenca}
                                                        /*jsonConfiguracao={jsonConfiguracao}*/
                                                        title={title}
                                                        arrayHelpers={arrayHelpers}
                                                        item={item}
                                                        ind={ind}
                                                        tipoRecursoFinanceiroSelecionado={tipoRecursoFinanceiroSelecionado}
                                                        setExpandiu={setExpandiu}
                                                    />
                                                </GridItem2>
                                            </GridContainer>
                                        )}
                                        
                                        {isXsDownScreen && values.recursosFinanceirosPagination.length - 1 !== ind && (
                                            <CardGridDividerElementos />
                                        )}
                                    </GridItem12>
                                )

                            } else {

                                return ''
                            }
                        })}
                    </GridContainer>

                    <TablePaginationPadraoRecursosFinanceiros
                        values={values}
                        setFieldValue={setFieldValue}
                    />

                    <GridContainer>
                        <GridItem6xs12>
                            <CustomizedDialogsPopup
                                maxWidth='sm'
                                popupTitle={LABEL.buttonAlterarTodosFamiliaresInventario}
                                PopupButton={ButtonAlterarTodosFamiliaresInventario}
                                popupComponent={
                                    <>
                                        <AlterarFamiliarInventarioRecursosFinanceiros
                                            values={values}
                                            handleChange={handleChange}
                                        />

                                        <ButtonAlterarFamiliarInventarioRecursosFinanceiros
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                    </>
                                }
                            />
                        </GridItem6xs12>

                        <GridItem5xs12>
                            <ButtonIncluirLinha
                                label={LABEL.buttonIncluirRecursosFinanceiros} 
                                align='right'
                                disabled={familiaresList(values).length === 0 ? true : false}
                                onClick={() => 
                                    {
                                        incrementaContRecursosFinanceiros(values)
                                        arrayHelpers.push({
                                            id: values.contRecursosFinanceiros,
                                            familiar: HARDCODE.idFamiliarCliente,
                                        })
                                        setPageInclusaoRecursosFinanceiros(values, setFieldValue)
                                    }
                                }
                            />
                        </GridItem5xs12>
                    </GridContainer>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormRecursosFinanceiros